import React from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';

// Shared countdown pill used across Conversations + Messages + Agent Testing
const countdownAnimationStyle = `
  @keyframes countdownPulse {
    0% { box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.45); }
    70% { box-shadow: 0 0 0 8px rgba(24, 144, 255, 0); }
    100% { box-shadow: 0 0 0 0 rgba(24, 144, 255, 0); }
  }
`;

/**
 * Formats a duration in seconds into a compact human-readable string.
 *
 * Args:
 *     totalSeconds: The number of seconds to format.
 *
 * Returns:
 *     A formatted string like "7m 21s", "1h 5m", or "9s".
 */
const formatDuration = (totalSeconds) => {
    if (totalSeconds < 60) return `${totalSeconds}s`;

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const remainingSeconds = totalSeconds % 60;

    if (hours > 0) {
        // For durations >= 1 hour, show hours + minutes (drop seconds for brevity)
        return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
    }

    // For durations < 1 hour, show minutes + seconds
    return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;
};

/**
 * Countdown pill (same visual/animation as the Conversation list item).
 *
 * Note: pass `animationKey={seconds}` if you want the pulse to restart exactly
 * when the displayed second changes (helps keep pulse + number visually in sync).
 */
const CountdownPill = ({
    seconds,
    isDarkMode,
    size = 'sm', // 'sm' | 'md'
    animationKey
}) => {
    if (!seconds || seconds <= 0) return null;

    const isMd = size === 'md';
    const height = isMd ? 28 : 18;
    const paddingX = isMd ? 10 : 6;
    const fontSize = isMd ? 13 : 12;
    const iconMargin = isMd ? 6 : 4;
    const borderRadius = Math.round(height / 2);

    return (
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            <style dangerouslySetInnerHTML={{ __html: countdownAnimationStyle }} />
            <div
                key={animationKey}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    height,
                    padding: `0 ${paddingX}px`,
                    borderRadius,
                    border: '1px solid #1890ff',
                    background: isDarkMode ? 'rgba(24, 144, 255, 0.16)' : 'rgba(24, 144, 255, 0.10)',
                    color: '#1890ff',
                    fontSize,
                    fontWeight: 600,
                    lineHeight: `${height}px`,
                    whiteSpace: 'nowrap',
                    animation: 'countdownPulse 1s ease-out infinite',
                }}
            >
                <ClockCircleOutlined style={{ marginRight: iconMargin }} />
                {formatDuration(seconds)}
            </div>
        </div>
    );
};

export default CountdownPill;
export { formatDuration };













